export default __webpack_public_path__ + "/dist/images/recipe-banner-img.22b955fdce4d17c36a0b55f0bd8efe71.jpg";